import { render, staticRenderFns } from "./AssessmentGlobalSingleTaskModal.vue?vue&type=template&id=0fb7f179&scoped=true&"
import script from "./AssessmentGlobalSingleTaskModal.vue?vue&type=script&lang=js&"
export * from "./AssessmentGlobalSingleTaskModal.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentGlobalSingleTaskModal.vue?vue&type=style&index=0&id=0fb7f179&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb7f179",
  null
  
)

export default component.exports